exports.components = {
  "component---src-templates-landing-page-template-index-js": () => import("./../../../src/templates/LandingPageTemplate/index.js" /* webpackChunkName: "component---src-templates-landing-page-template-index-js" */),
  "component---src-templates-recipe-page-template-index-js": () => import("./../../../src/templates/RecipePageTemplate/index.js" /* webpackChunkName: "component---src-templates-recipe-page-template-index-js" */)
}

